<template>
  <v-row justify="center">
    <v-dialog :value="dialog" persistent max-width="720px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Relatório Geral</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="body-2 grey--text mb-4">
            Campo vazio não filtra. Baixar sem marcar nada traz a campanha
            inteira.
          </p>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-select
                label="Segmento"
                v-model="idBand"
                :items="opcoesSegmento"
                :loading="carregandoSegmento"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-file-table-box-multiple-outline"
                multiple
                chips
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Empresa"
                v-model="idEmpresa"
                :items="opcoesEmpresa"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-domain"
                multiple
                chips
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Função"
                v-model="idFuncao"
                :items="opcoesFuncao"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-account-tie"
                multiple
                chips
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Colaborador"
                v-model="idColaborador"
                :items="opcoesColaborador"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-account"
                multiple
                chips
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Ativo"
                v-model="ativo"
                :items="opcoesAtivo"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-account-check"
                multiple
                chips
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Situação"
                v-model="situacao"
                :items="opcoesSituacao"
                item-text="descricao"
                item-value="id"
                prepend-inner-icon="mdi-account-details"
                multiple
                chips
                clearable
              />
            </v-col>
          </v-row>

          <v-checkbox
            v-if="idTipoFechamentoTela"
            v-model="aplicarFiltroTela"
            label="Aplicar o filtro de semana da tela"
            hide-details
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">Cancelar</v-btn>
          <RelatorioXlsx
            apuracaoGeral
            :filter="filtroRelatorio"
            :fileName="apuracao.title"
            label="Baixar"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import sistema from "@/services/http/sistemaService";
import RelatorioXlsx from "../RelatorioXlsx";

// Fixos ate a API expor o catalogo; quando expuser, troque pelo fetch.
const OPCOES_ATIVO = [
  { id: "S", descricao: "Ativo" },
  { id: "N", descricao: "Inativo" }
];

// Catalogo completo; o select so exibe as situacoes presentes na campanha.
const SITUACOES = [
  { id: "A", descricao: "Ativo" },
  { id: "D", descricao: "Demitido" },
  { id: "E", descricao: "Licença Mater." },
  { id: "F", descricao: "Férias" },
  { id: "I", descricao: "Apos. por Incapacidade Permanente" },
  { id: "P", descricao: "Cessão / Requisição" },
  { id: "T", descricao: "Af.Ac.Trabalho" },
  { id: "U", descricao: "Outros" },
  { id: "V", descricao: "Aviso Prévio" }
];

export default {
  name: "ModalRelatorioGeral",

  components: { RelatorioXlsx },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    // Linhas de /campanhas/apuracao-campanha. Empresa, funcao e colaborador
    // saem daqui para o select oferecer so quem esta na campanha; campanha no
    // modo antigo chega vazia e esses tres ficam sem opcao.
    itemsApuracao: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      opcoesAtivo: OPCOES_ATIVO,
      catalogoSegmento: [],
      catalogoEmpresa: [],
      carregandoSegmento: false,
      idBand: [],
      idEmpresa: [],
      idFuncao: [],
      idColaborador: [],
      ativo: [],
      situacao: [],
      aplicarFiltroTela: false
    };
  },

  computed: {
    ...mapState("campanha", {
      apuracaoFilters: state => state.apuracao.filters
    }),

    ...mapGetters({
      apuracao: "campanha/getApuracao"
    }),

    // Semana escolhida no FilterApuracaoCards; so existe em campanha de
    // id_tipo_dado "C". Sem ela o checkbox nao renderiza.
    idTipoFechamentoTela() {
      return this.apuracaoFilters?.id_tipo_fechamento || null;
    },

    // A apuracao nao traz a bandeira, so id_empresa; o vinculo vem do catalogo
    // de empresas. Chave em String porque os dois lados sao de origens
    // diferentes e o tipo do id nao e garantido.
    bandPorEmpresa() {
      const mapa = new Map();
      for (const empresa of this.catalogoEmpresa) {
        mapa.set(String(empresa.id_empresa), empresa.id_band);
      }
      return mapa;
    },

    // Quem esta na campanha sai das linhas; o rotulo, do catalogo de bandeiras.
    // Sem catalogo carregado nada resolve, e o select cai na lista inteira —
    // derivar daria vazio e o filtro sumiria da tela.
    opcoesSegmento() {
      const presentes = new Map();
      for (const row of this.itemsApuracao) {
        const id = this.bandDaLinha(row);
        if (id === null || id === undefined || id === "") continue;
        if (!presentes.has(id)) presentes.set(id, this.descricaoSegmento(id));
      }

      if (!presentes.size) return this.catalogoSegmento;

      return [...presentes.entries()]
        .map(([id, descricao]) => ({ id, descricao }))
        .sort((a, b) => (a.descricao > b.descricao ? 1 : -1));
    },

    // Cascata: cada nivel oferece so o que sobrevive ao nivel acima.
    linhasDoSegmento() {
      if (!this.idBand.length) return this.itemsApuracao;
      return this.itemsApuracao.filter(r =>
        this.idBand.includes(this.bandDaLinha(r))
      );
    },

    opcoesEmpresa() {
      return this.distintos(this.linhasDoSegmento, "id_empresa", [
        "apelido",
        "nome_empresa"
      ]);
    },

    linhasDaEmpresa() {
      if (!this.idEmpresa.length) return this.linhasDoSegmento;
      return this.linhasDoSegmento.filter(r =>
        this.idEmpresa.includes(r.id_empresa)
      );
    },

    opcoesFuncao() {
      return this.distintos(this.linhasDaEmpresa, "id_funcao", ["funcao"]);
    },

    linhasDaFuncao() {
      if (!this.idFuncao.length) return this.linhasDaEmpresa;
      return this.linhasDaEmpresa.filter(r =>
        this.idFuncao.includes(r.id_funcao)
      );
    },

    opcoesColaborador() {
      return this.distintos(this.linhasDaFuncao, "id_colaborador", [
        "colaborador"
      ]);
    },

    // Situacao das linhas da campanha inteira, nao da cascata: e o recorte de
    // pessoal, e nao muda ao escolher empresa ou funcao. Linha sem a coluna
    // (view ainda sem ce.situacao) cai no catalogo inteiro — derivar daria uma
    // lista vazia e o filtro sumiria da tela. Codigo fora do catalogo entra
    // com o proprio codigo como rotulo, para nao ficar inalcancavel.
    opcoesSituacao() {
      const presentes = new Set();
      for (const row of this.itemsApuracao) {
        if (row.situacao) presentes.add(row.situacao);
      }

      if (!presentes.size) return SITUACOES;

      const conhecidas = SITUACOES.filter(o => presentes.has(o.id));
      const desconhecidas = [...presentes]
        .filter(id => !SITUACOES.some(o => o.id === id))
        .map(id => ({ id, descricao: id }));

      return [...conhecidas, ...desconhecidas];
    },

    // Array vazio e truthy, entao o RelatorioXlsx nao o descartaria e mandaria
    // a chave vazia na query. Aqui ela so entra se tiver selecao.
    filtroRelatorio() {
      const filtro = { id_campanha: this.$route.params.idCampanha };

      if (this.idBand.length) filtro.id_band = this.idBand;
      if (this.idEmpresa.length) filtro.id_empresa = this.idEmpresa;
      if (this.idFuncao.length) filtro.id_funcao = this.idFuncao;
      if (this.idColaborador.length) filtro.id_colaborador = this.idColaborador;
      if (this.ativo.length) filtro.ativo = this.ativo;
      if (this.situacao.length) filtro.situacao = this.situacao;
      if (this.aplicarFiltroTela && this.idTipoFechamentoTela)
        filtro.id_tipo_fechamento = this.idTipoFechamentoTela;

      return filtro;
    }
  },

  watch: {
    dialog(aberto) {
      if (aberto && !this.catalogoSegmento.length) this.fetchSegmentos();
    },

    // Estreitar a cascata deixaria selecao orfa filtrando escondido.
    opcoesEmpresa(opcoes) {
      this.idEmpresa = this.intersecta(this.idEmpresa, opcoes);
    },

    opcoesFuncao(opcoes) {
      this.idFuncao = this.intersecta(this.idFuncao, opcoes);
    },

    opcoesColaborador(opcoes) {
      this.idColaborador = this.intersecta(this.idColaborador, opcoes);
    },

    opcoesSituacao(opcoes) {
      this.situacao = this.intersecta(this.situacao, opcoes);
    }
  },

  methods: {
    // Uma opcao por id; o texto vem da primeira chave preenchida de textKeys.
    distintos(rows, idKey, textKeys) {
      const mapa = new Map();

      for (const row of rows) {
        const id = row[idKey];
        if (id === null || id === undefined || id === "") continue;
        if (mapa.has(id)) continue;

        const texto = textKeys.map(k => row[k]).find(v => v);
        mapa.set(id, { id, descricao: texto || String(id) });
      }

      return [...mapa.values()].sort((a, b) =>
        a.descricao > b.descricao ? 1 : -1
      );
    },

    intersecta(selecionados, opcoes) {
      const ids = opcoes.map(o => o.id);
      return selecionados.filter(id => ids.includes(id));
    },

    // Se um dia a view expuser id_band, ela ganha do catalogo e o fetch de
    // empresas pode sair.
    bandDaLinha(row) {
      if (row.id_band !== null && row.id_band !== undefined && row.id_band !== "")
        return row.id_band;
      return this.bandPorEmpresa.get(String(row.id_empresa));
    },

    // Catalogo so para rotular; quem esta na campanha vem das linhas. Bandeira
    // sem correspondencia no catalogo fica com o proprio id no lugar do nome,
    // para nao virar opcao anonima.
    descricaoSegmento(id) {
      const item = this.catalogoSegmento.find(o => String(o.id) === String(id));
      return item ? item.descricao : `Segmento ${id}`;
    },

    // Empresas sem filtro de propósito: o catalogo aqui so serve de mapa
    // empresa -> bandeira, e recortar por calcula_comissao deixaria empresa da
    // campanha sem bandeira resolvida.
    async fetchSegmentos() {
      this.carregandoSegmento = true;
      try {
        const [bandeiras, empresas] = await Promise.all([
          sistema()
            .tipoBandeiras()
            .show({ per_page: -1 }, { notification: false }),
          sistema()
            .empresa()
            .show({ per_page: -1 }, { notification: false })
        ]);

        this.catalogoSegmento = (bandeiras.data.data || []).map(item => ({
          id: item.id_band,
          descricao: item.descricao
        }));
        this.catalogoEmpresa = empresas.data.data || [];
      } catch (e) {
        this.catalogoSegmento = [];
        this.catalogoEmpresa = [];
      } finally {
        this.carregandoSegmento = false;
      }
    },

    close() {
      this.$emit("closeModal");
    }
  }
};
</script>
